import type { ReactElement } from 'react';

import type { ContactsTierSelectProps } from '@ctct/payflow-ui';

import { EmailPlansWidgetContent } from './EmailPlansWidgetContent';
import { PricingTierDialog } from './PricingTierDialog';
import type { EmailPlansWidgetProps } from './useEmailPlansWidget';
import { WithStatusHandling } from '../WithStatusHandling';

type Props = EmailPlansWidgetProps & {
  pricingTierDialogOnly?: boolean;
  contactsTierSelectWidget?: ReactElement<ContactsTierSelectProps>;
};

export const EmailPlansWidget = ({
  status,
  data,
  handlers,
  hooks,
  pricingTierDialogOnly,
  externalHooks,
  contactsTierSelectWidget,
}: Props) => {
  const pricingTierDialog =
    status === 'loaded' ? (
      <PricingTierDialog data={data} hooks={hooks} handlers={handlers} currency={data?.getCurrency()} />
    ) : null;

  if (pricingTierDialogOnly) {
    return pricingTierDialog;
  }

  return (
    <WithStatusHandling
      skeletonHeight={120}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {pricingTierDialog}
      {status === 'loaded' && (
        <EmailPlansWidgetContent
          data={data}
          handlers={handlers}
          hooks={hooks}
          externalHooks={externalHooks}
          contactsTierSelectWidget={contactsTierSelectWidget}
        />
      )}
    </WithStatusHandling>
  );
};
